import i18n from 'i18next'
import english from './english.json'
import spanish from './spanish.json'
import { initReactI18next } from 'react-i18next';
import Languagedetector from 'i18next-browser-languagedetector';

i18n
.use(initReactI18next)
.use(Languagedetector)
.init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
        en: english,
        sp: spanish
    }
  });
// i18next.use(initReactI18next).init({
//     compatibilityJSON: 'v3',
//     lng: 'en',
//     resources: {
//         en: english,
//         sp: spanish
//     },
//     react: {
//         useSuspense: false
//     },

// });

export default i18n;